import { Controller } from "@hotwired/stimulus";
const options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};
// Connects to data-controller="geolocation"
export default class extends Controller {
  static values = {
    user: String,
    baseurl: String,
    deployedurl: String,
    cookies: Object,
    token: String,
    efector: String,
    paciente: String,
    visita: String,
    fecha: String,
    especialidad: String,
    profesion: String,
    financiadora: String,
  };

  success = (pos) => {
    const crd = pos.coords;
    this.lat = crd.latitude;
    this.long = crd.longitude;

    const warningMessage = document.querySelector('[data-geo-warning]');
    if (warningMessage) warningMessage.style.display = "none";

    const activatedMessage = document.querySelector('[data-geo-activada]');
    if (activatedMessage) activatedMessage.style.display = "block";
    if (activatedMessage) {
      this.lat = crd.latitude;
      this.long = crd.longitude;

      const warning = this.element.querySelector("[data-geo-warning]");
      const activated = this.element.querySelector("[data-geo-activada]");

      warning.style.display = "none";
      activated.style.display = "block";

      const fechaRaw = this.element.dataset.geolocationFecha;
      const fechaISO = fechaRaw
        .replace(" ", "T")
        .replace(/\s(-\d{2})(\d{2})$/, "$1:$2");
      // Buscar recursoId en ambas vistas (qr_scan usa visita, visita_detalle usa recurso-id)
      const recursoId = this.element.dataset.geolocationRecursoId || this.element.dataset.geolocationVisita;
      const rutaRails = `/visitas_efector/${recursoId}/validacion_manual_geolocalizacion`;

      activatedMessage.innerHTML = `
        <form action="${rutaRails}" method="POST" style="">
          <input type="hidden" name="authenticity_token" value="${document.querySelector('meta[name="csrf-token"]').content}">

          <input type="hidden" name="paciente_id" value="${this.element.dataset.geolocationPaciente}">
          <input type="hidden" name="location_user" value="${this.lat}, ${this.long}">
          <input type="hidden" name="location_efector" value="${this.lat}, ${this.long}">
          <input type="hidden" name="location_internacion" value="${this.lat}, ${this.long}">
          <input type="hidden" name="distancia_max_km" value="1">
          <input type="hidden" name="fecha_asignada" value="${fechaISO}">

          <button
            type="submit"
            style="
              color: var(--bs-link-color);
              background: none;
              border: none;
              padding: 0;
              margin: 16px auto 0 auto;
              font-size: 12.8px;
              cursor: pointer;
              text-decoration: none;
              display: block;
              width: fit-content;
              font-family: inherit;
            "
            onmouseover="this.style.color='var(--bs-link-hover-color)';"
            onmouseout="this.style.color='var(--bs-link-color)';"
          >
            Validar con geolocalización
          </button>
        </form>
        <div style="color:green;font-size:12.8px; display:block; text-align: center; margin-top: 30px;">La geolocalización está activada.</div>
      `;
    }
    // this.sendToBackend()
  };

  sendToBackend() {
    const recursoId = this.element.dataset.geolocationRecursoId
    let baseUrl = document.querySelector('meta[name="base-url"]').getAttribute('content');
    const endpoint = `/recurso-visita/${recursoId}/validate-geolocation`
    
    console.log("baseUrl", baseUrl)
    console.log("endpoint", endpoint)
    console.log("Efector", this.element.dataset.geolocationEfector)
    console.log("Pacient", this.element.dataset.geolocationPacient)
    console.log("this.element.dataset.geolocationFecha", this.element.dataset.geolocationFecha)
    const fechaRaw = this.element.dataset.geolocationFecha;

    console.log("this.cookiesValue.type", this.cookiesValue.type)
    console.log("this.cookiesValue.entity_id", this.cookiesValue.entity_id)
    console.log("this.cookiesValue.owner", this.cookiesValue.owner)
    console.log("this.lat", this.lat)
    console.log("this.long", this.long)

    fetch(baseUrl + endpoint, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${Cookies.get('access_token')}`,
        "Content-Type": "application/json",
        'role-type': this.cookiesValue.type,
        'entity-id': this.cookiesValue.entity_id,
      },
      body: JSON.stringify({
        paciente_id: this.element.dataset.geolocationPaciente,
        qr_validation: true,
        location_efector: this.lat + ", " + this.long,
        location_efector: this.lat + ", " + this.long,
        fecha_asignada: fechaRaw
      })
    })
      .then(r => r.json())
      .then(data => {
        console.log("Respuesta geolocalización:", data)
        alert("Validación enviada correctamente.")
      })
      .catch(err => console.error("Error enviando validación:", err))
  }
  // error(err) {
  //   console.warn(`ERROR(${err.code}): ${err.message}`);
  //   // Manejo de errores de geolocalización
  //   // Mostrar un mensaje de error al usuario
  //   // const warningMessage = document.querySelector('[data-geo-warning]');
  //   // if (warningMessage) warningMessage.style.display = "block"; // Asegura que el warning se muestre si hay error
    
  //   // Alerta al usuario que debe activar la geolocalización
  //   alert("Activar Geolocalización para validación por QR.");

  //   const activatedMessage = document.querySelector('[data-geo-activada]');
  //   if (activatedMessage) activatedMessage.style.display = "none"; // Oculta el mensaje de activada si hay error
  // }

  error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    
    // Mostrar mensaje de warning solo si está oculto
    const warningMessage = document.querySelector('[data-geo-warning]');
    if (warningMessage && warningMessage.style.display !== "block") {
      warningMessage.style.display = "block";
    }

    // Ocultar mensaje de activada
    const activatedMessage = document.querySelector('[data-geo-activada]');
    if (activatedMessage) activatedMessage.style.display = "none";
  }


  qrScan() {
    // Evitar inicializar múltiples scanners
    if (this.scannerInitialized) {
      return;
    }
    
    // Validar que el elemento reader exista antes de inicializar
    const readerElement = document.getElementById("reader");
    if (!readerElement) {
      setTimeout(() => this.qrScan(), 500);
      return;
    }
    
    this.scannerInitialized = true;
    const scanner = new Html5QrcodeScanner("reader", {
      // Scanner will be initialized in DOM inside element with id of 'reader'

      qrbox: {
        width: 250,
        height: 250,
      }, // Sets dimensions of scanning box (set relative to reader element width)
      fps: 20, // Frames per second to attempt a scan
    });
    scanner.render(
      (result) => {
        // Separar el result en los parámetros que necesita el post de validación de qr en recurso visita
        var pacienteId = this.element.dataset.geolocationPaciente;
        var userLocation = result.split("|")[1];
        var qrRecursoVisitaId = result.split("|")[3];
        // IMPORTANTE: Extraer fecha del QR, no del data attribute (que es UTC)
        // QR contiene: 2026-08-05 20:07:00 -0300 (hora Argentina, UTC-3)
        // Backend espera UTC, así que sumar 3 horas
        var fechaQRRaw = result.split("|")[4];  // "2026-08-05 20:07:00 -0300"
        var [fechaParte, horaParte] = fechaQRRaw.split(" ").slice(0, 2);  // "2026-08-05", "20:07:00"
        var [horas, minutos] = horaParte.split(":").slice(0, 2);
        
        // Usar Date para manejar correctamente cambio de día al sumar 3 horas
        var dateObj = new Date(fechaParte + "T" + horaParte + "Z");  // Interpreta como UTC-0
        dateObj.setUTCHours(dateObj.getUTCHours() + 3);  // Suma 3 horas en UTC
        
        // Formatea a YYYY-MM-DDTHH:MM
        var year = dateObj.getUTCFullYear();
        var month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
        var day = String(dateObj.getUTCDate()).padStart(2, '0');
        var utcHours = String(dateObj.getUTCHours()).padStart(2, '0');
        var utcMins = String(dateObj.getUTCMinutes()).padStart(2, '0');
        var fechaAsignada = year + "-" + month + "-" + day + "T" + utcHours + ":" + utcMins;
        

        let fechaISO = fechaAsignada;  // Ya está en formato UTC correcto
        var internacionLocation = userLocation;
        // Usar la primera coordenada del QR como location_efector (no el GPS actual)
        var efectorQRLocation = result.split("|")[0];  // Parte 0 del QR
        var efectorLocation = efectorQRLocation;  // Sin espacios, consistente con QR
        var body = {
          paciente_id: pacienteId,
          qr_validation: true,
          location_efector: efectorLocation,
          fecha_asignada: fechaISO,
          qr_recurso_visita_id: qrRecursoVisitaId,
        };
        var recursoVisitaId = this.element.dataset.geolocationVisita;
        var efectorEspecialidad = this.element.dataset.especialidad;
        var efectorProfesion = this.element.dataset.profesion;
        var efectorId = this.element.dataset.geolocationEfector;
        var fecha = this.element.dataset.geolocationFecha;
        var financiadora = this.element.dataset.financiadora;
        
        // Hacer un fetch al post para obtener una respuesta de validación
        fetch(
          `${this.baseurlValue}/recurso-visita/${recursoVisitaId}/validate-geolocation`,
          {
            method: "POST", // Could be dynamic with Stimulus values
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${atob(this.tokenValue)}`,
              "Content-Type": "application/json",
              'role-type': this.cookiesValue.type,
              'entity-id': this.cookiesValue.entity_id,
              'owner': this.cookiesValue.owner
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.valido) {
              if (
                window.location.hostname === "localhost" ||
                window.location.hostname === "127.0.0.1"
              ) {
                // Redirección en el entorno de desarrollo
                var baseUrl = "http://localhost:3000";
              } else {
                // Redirección en el entorno de producción
                var baseUrl = this.deployedurlValue;
              }
              // Con la respuesta de validación, ejecutar una acción (ok: Success!; falla: Ir a validación manual)
              document.getElementById("result").innerHTML =
              // <h2>La distancia entre el efector y el paciente es  ${data.distamce_km}km</h2>
              `
              <h2>Validación exitosa</h2>
              <div class="d-flex gap-3 justify-content-center">
                <p><a href="${baseUrl}/visitas_efector" class="text-white">Ir al Inicio</a></p>
                <p><a href="${baseUrl}/visitas_efector_registro/${data.visita_id}/registro?id_recurso_visita=${recursoVisitaId}&financiadora_id=${financiadora}&especialidad_id=${efectorEspecialidad}&profesion_id=${efectorProfesion}&efector_id=${efectorId}&fecha=${fecha}&visita_id=${data.visita_id}" class="text-white">Registro de visita</a></p>
              </div>
                `;
              const validacionManual =
                document.getElementById("validacionManual");
              validacionManual.remove();
            } else {
              // Mostrar mensaje de error del backend si existe
              // Validamos si hay un mensaje específico del backend
              const mensajeError = data.mensaje; 

              document.getElementById("result").innerHTML = `
                <h3>No es posible realizar la validación</h3>
                ${mensajeError ? `<h3>Motivo: ${mensajeError}</h3>` : ''}
                <p style="margin-top: 15px;">En caso que consideres esto un error puedes realizar la validación manual.</p>
              `;
              // const mensajeError = data.mensaje ? data.mensaje : "No es posible realizar la validación";
              // console.log("Mensaje a mostrar:", mensajeError);
              // document.getElementById("result").innerHTML = `
              //   <h2>No es posible realizar la validación</h2>
              //   <h2>${mensajeError}</h2>
              //   <p>En caso que consideres esto un error puedes realizar la validación manual</p>
              // `;
            }
          });
        // Prints result as a link inside result element
        scanner.clear();
        // Clears scanning instance

        document.getElementById("reader").remove();
      },
      (error) => {
        // Silenciar errores normales de QR no detectado (scanner siempre reporta esto)
        // Solo mostrar errores reales si los hay
      }
    );
    this.disconnect();
  }

  connect() {
    this.distancia = 17;
    this.scannerInitialized = false;  // Flag para evitar inicializar múltiples veces
    // console.log("decoded", atob(this.tokenValue));
    navigator.geolocation.getCurrentPosition(this.success, this.error, options);
    // Inicializar el scanner QR después de obtener la geolocalización
    setTimeout(() => {
      this.qrScan();
    }, 500);
  }
}